import { Component, Vue } from 'vue-property-decorator'

import Loader from '@/components/Loader/index.vue'

import BadgePerson from '@/components/BadgePerson/index.vue'

import { validationMixin } from 'vuelidate'
import { required } from 'vuelidate/lib/validators'
import { Validations } from 'vuelidate-property-decorators'

import fetch from '@/helpers/fetch'

import MessageSuccess from '@/components/edit/MessageSuccess/index.vue'
import ModalInitial from './ModalInitial/index.vue'
import YearMonthList from './YearMonthList/index.vue'
import { bus } from '@/main'
import { set } from 'vue/types/umd'

@Component({
	components: {
		Loader,
		BadgePerson,
		ModalInitial,
		MessageSuccess,
		YearMonthList,
	},
	mixins: [validationMixin],
})
export default class InitialManagement extends Vue {
	get elaboratorId() {
		return this.$store.state.initials.elaboratorId
	}

	get elaboratorById() {
		return this.$store.state.initials.elaboratorById
	}

	get elaboratorByIdArray() {
		return this.$store.state.initials.elaboratorByIdArray
	}

	//

	get reviewerId() {
		return this.$store.state.initials.reviewerId
	}

	get reviewerById() {
		return this.$store.state.initials.reviewerById
	}

	get reviewerByIdArray() {
		return this.$store.state.initials.reviewerByIdArray
	}

	get initials() {
		// cria referencia circular
		const mappedInitials =
			this.$store.state.initials.initials?.map((initial) => {
				return { ...initial, initial }
			}) || []
		return [...mappedInitials]
	}

	loading = false
	async mounted() {
		this.loading = true
		bus.$on('open-modal-initials', (id) => {
			this.$store.dispatch('selectInitialId', id)
			this.$bvModal.show('modal-initial-management')
		})

		await this.$store.dispatch('fetchInitials')

		this.loading = false
	}

	async filter(elaboratorId, reviewerId) {
		await this.$store.dispatch('filterInitials', {
			elaborator_user_id: elaboratorId || null,
			reviewer_user_id: reviewerId || null,
		})
	}

	creating = false
	async newInitial() {
		this.creating = true
		const result = await this.$store.dispatch('createInitial')

		this.$store.dispatch('selectInitialId', result.id)

		await this.$store.dispatch('fetchInitials')

		this.$bvModal.show('modal-initial-management')
		this.creating = false
	}

	data() {
		return {
			name: '',
		}
	}

	@Validations()
	validations() {
		return {
			name: {
				required,
			},
		}
	}

	successGroup = false
	creatingGroup = false
	errorMessage = ''
	openCreateGroupModal() {
		this.successGroup = false
		this.creatingGroup = false
		this.errorMessage = ''
		this.$bvModal.show('modal-create-group')
	}

	async save(e) {
		e.preventDefault()
		this.creatingGroup = true
		this.errorMessage = ''

		const that: any = this
		const name = that.name
		const resp = await fetch.post('/api/groups', { name })

		if (resp.ok) {
			this.successGroup = true
			bus.$emit('get-groups-options')
		} else {
			this.errorMessage = resp.error
		}
		this.creatingGroup = false
	}
}
